export default __webpack_public_path__ + "static/media/MauiCard2.9cc4fb49.png";